import { render, staticRenderFns } from "./AppSettingPage.vue?vue&type=template&id=00d232e6"
import script from "./AppSettingPage.vue?vue&type=script&lang=js"
export * from "./AppSettingPage.vue?vue&type=script&lang=js"
import style0 from "./AppSettingPage.vue?vue&type=style&index=0&id=00d232e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports